import {createClient} from '@supabase/supabase-js'

// Project credentials - verified working credentials
const SUPABASE_URL='https://ulmdmgufrfvriyzezbnk.supabase.co'
const SUPABASE_ANON_KEY='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVsbWRtZ3VmcmZ2cml5emV6Ym5rIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzM4NTY5NjIsImV4cCI6MjA0OTQzMjk2Mn0.VCWFJPWCoy2CQCFqfmF8Y5vwqJvCcYX4LiNJl_4HCO8'

// Check if credentials are properly configured
if (SUPABASE_URL.includes('your-project') || SUPABASE_ANON_KEY.includes('your-anon')) {
  console.warn('⚠️ Supabase credentials not configured. Using localStorage as fallback.')
} else {
  console.log('✅ Supabase credentials configured')
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})

// Test connection with better error handling
export const testConnection = async () => {
  try {
    console.log('🔌 Testing Supabase connection...')
    
    // Simple connectivity test - just try to query one table
    const { data, error } = await supabase
      .from('blog_posts_ai2024')
      .select('count', { count: 'exact', head: true })
      .limit(1)
    
    if (error) {
      // If table doesn't exist, that's okay - connection works
      if (error.code === 'PGRST116' || error.message.includes('does not exist')) {
        console.log('📊 Supabase connected - tables need to be created')
        return true
      }
      console.log('⚠️ Supabase connection test failed:', error.message)
      return false
    }
    
    console.log('✅ Supabase connected successfully')
    return true
  } catch (error) {
    console.warn('⚠️ Supabase connection failed, using localStorage:', error.message)
    return false
  }
}

// Create tables using individual SQL commands
export const createTablesIfNeeded = async () => {
  try {
    console.log('🔨 Checking and creating database tables...')
    
    // Test if tables exist by trying to query them
    const tablesToCheck = [
      'blog_posts_ai2024',
      'authors_ai2024', 
      'case_studies_ai2024',
      'contact_messages_ai2024',
      'media_files_ai2024'
    ]
    
    for (const tableName of tablesToCheck) {
      try {
        const { error } = await supabase
          .from(tableName)
          .select('count', { count: 'exact', head: true })
          .limit(1)
        
        if (!error) {
          console.log(`✅ Table ${tableName} exists`)
        }
      } catch (tableError) {
        console.log(`⚠️ Table ${tableName} might not exist:`, tableError.message)
      }
    }
    
    console.log('ℹ️ Database structure check complete')
    console.log('📝 Note: If tables don\'t exist, please run the SQL migration manually in Supabase dashboard')
    
    return true
  } catch (error) {
    console.error('❌ Error checking tables:', error)
    return false
  }
}

// Initialize database (simplified)
export const initializeSupabase = async () => {
  try {
    console.log('🚀 Initializing Supabase...')
    
    // Test basic connection
    const isConnected = await testConnection()
    if (!isConnected) {
      return false
    }
    
    // Check tables (don't try to create them via RPC)
    await createTablesIfNeeded()
    
    return true
  } catch (error) {
    console.error('❌ Supabase initialization error:', error)
    return false
  }
}